/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`/OneSignalSDKWorker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
      //console.log('OS', window.OneSignal)
      // try {
      //   window.OneSignal.getUserId(function(userId) {
      //     console.log("OneSignal User ID:", userId);
      //     window.OneSignal.setExternalUserId(userId);
      //     window.OneSignal.setEmail(email); 
      //   });
      // } catch (error) {
      //   console.log(error)
      // }
    },
    registered () {
      console.log('Service worker has been registered.')
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated () {
      console.log('New content is available; please refresh.')
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
